// github.com/facebook/react/blob/master/src/vendor/core/emptyFunction.js

export interface EmptyFunctionFn {
  (): void;
  thatReturns<T>(arg: T): () => T;
  thatReturnsFalse(): false;
  thatReturnsTrue(): true;
  thatReturnsNull(): null;
  thatReturnsThis(): this;
  thatReturnsArgument<T>(arg: T): T;
}

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule emptyFunction
 */

function makeEmptyFunction<T>(arg: T) {
  return () => {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
const emptyFunction = (() => {}) as EmptyFunctionFn;

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = () => {
  return this as any;
};
emptyFunction.thatReturnsArgument = (arg) => {
  return arg;
};

export default emptyFunction;
